<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showCreateDepartment"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="create"
          class="fixed center-h-v bg-white rounded-md h-full md:h-auto shadow-2xl sm:w-2/5 w-full"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Create A Deparment</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="create_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ create_error }}
            </div>
          </transition>

          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Deparment Name</label>
              <input
                v-model="info.Name"
                type="text"
                required
                class="p-2 bg-gray-200 rounded-full w-full capitalize"
              />
            </div>
          </div>

          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Company</label>
              <el-select
                filterable
                class="bg-gray-200 rounded-full w-full border-none"
                v-model="info.LocationName"
                :default-first-item="true"
                @change="findBranchesByLocationId"
                placeholder="Enter a company"
              >
                <el-option
                  v-for="location in locations"
                  :key="location.LocationName"
                  :label="location.LocationName"
                  :value="location.LocationName"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Branch</label>
              <el-select
                filterable
                class="bg-gray-200 rounded-full w-full border-none"
                v-model="info.Branch"
                :default-first-item="true"
                @change="findBranchByName"
                placeholder="Enter a branch"
              >
                <el-option
                  v-for="branch in branchesToSelect"
                  :key="branch.Id"
                  :label="`${branch.Name} - ${branch.Location}`"
                  :value="`${branch.Name} - ${branch.Location}`"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <!-- <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Department Manager</label>
              <el-select
                filterable
                class="bg-gray-200 rounded-full w-full border-none"
                v-model="info.Fullname"
                :default-first-item="true"
                @change="findDepartmentManagers"
                placeholder="Enter a manager"
              >
                <el-option
                  v-for="manager in managers"
                  :key="manager.Id"
                  :label="`${manager.EmployeeNo} - ${manager.Fullname}`"
                  :value="`${manager.EmployeeNo} - ${manager.Fullname}`"
                >
                </el-option>
              </el-select>
            </div>
          </div> -->

          <div class="text-sm col-span-2 p-4">
            <label class="block pb-1">Department Manager</label>
            <!-- {{ jobTitles }} -->
            <el-select
              filterable
              class="bg-gray-200 rounded-full w-full border-none"
              v-model="info.DepartmentManager"
              placeholder="Enter a manager name"
            >
              <el-option
                v-for="jobTitle in jobTitles"
                :key="jobTitle.Id"
                :value="jobTitle.Id"
                :label="jobTitle.Name"
              >
                {{ jobTitle.Name }}
              </el-option>
            </el-select>
          </div>

          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Create
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
import decryptData from "@/utils/decrypt";
export default {
  name: "CompanySetupCreateDepartment",
  props: ["showCreateDepartment"],
  components: { Loader },
  data() {
    return {
      decryptDataLocal: "",
      decryptionKey: "",
      locations: [],
      managers: [],
      branches: [],
      departments: [],
      employees: [],
      isBranchDisabled: true,
      isDepartmentManagerDisabled: true,
      branchesToSelect: [],
      departmentsToSelect: [],
      jobTitles: [],
      // searchInput: '',
      info: {
        LocationName: null,
        Location: null,
        Branch: null,
        DepartmentManager: null,
        LocationId: null,
        BranchId: null,
        JobTitleId: null,
        Name: null,
        Fullname: null,
      },
      create_error: null,
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },
  created() {
    this.getLocations();
    this.getBranches();
    // this.getDepartments()
    this.getEmployees();
    this.getJobTitles();
    // this.getDes()
    this.decryptionKey = this.$decryptionKey;
    this.decryptDataLocal = decryptData;
  },
  methods: {
    close() {
      this.$emit("close");
    },
    clearBranch() {
      this.info.Name = null;
    },

    async fetchBranches(queryString, callback) {
      // fetch locations
      // based on the user input and call the callback function
      // with the resulting suggestions
      if (queryString) {
        //console.log(queryString)
        this.branchesToSelect = this.branchesToSelect.filter((branch) =>
          branch?.Name.toLowerCase().includes(queryString.toLowerCase())
        );
        callback(this.branchesToSelect);
      } else {
        callback(this.branchesToSelect);
      }
    },

    // /{organization}/setup/location/v1/request
    getLocations() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/location/${this.$ApiVersion}/request`,
          options
        )
        .then((response) => {
          this.loading = false;
          this.locations = response.data.Data.map((location) => {
            return { ...location, LocationName: location.Name };
          });
          return true;
        });
    },

    getJobTitles() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/jobtitle/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.jobTitles = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },

    findBranchesByLocationId(l) {
      // this.info.Branch = null;
      //console.log(this.locations, this.branches)
      this.branchesToSelect = this.branches.filter(
        (branch) =>
          branch.Location.trim().toLowerCase() === l.trim().toLowerCase()
      );
      this.info.LocationId = this.locations.find(
        (location) =>
          location.LocationName.trim().toLowerCase() === l.trim().toLowerCase()
      ).Id;

      //console.log(this.branchesToSelect, this.info.LocationId)

      if (this.branchesToSelect.length) {
        this.isBranchDisabled = false;
        this.isDepartmentManagerDisabled = false;
      } else {
        this.info.Branch = null;
        this.isBranchDisabled = true;
        this.isDepartmentManagerDisabled = true;
        this.create_error = `No branches at ${location.LocationName} yet. Create one first before proceeding`;

        setTimeout(() => {
          this.create_error = null;
        }, 3000);
      }
      //console.log(location, this.branchesToSelect)
    },

    getBranches() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/branch/${this.$ApiVersion}/request`,
          options
        )
        .then((response) => {
          this.loading = false;
          this.branches = response.data.Data.map((branch) => {
            return { ...branch, Branch: branch.Name };
          });
          //console.log(this.branches)
        });
    },

    // /{organization}/setup/department/v1/request

    getDepartments() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/department/${this.$ApiVersion}/request`,
          options
        )
        .then((response) => {
          this.loading = false;
          this.departments = response.data.Data;
          //console.log(this.departments)
        });
    },
    // /{organization}/employee/all/v1/request
    getEmployees() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/employee/all/${this.$ApiVersion}/request`,
          options
        )
        .then((response) => {
          this.loading = false;
          //console.log(response.data)
          this.managers = response.data.Data;

          //console.log(this.managers)
        });
    },

    findBranchByName(branch) {
      const [branchName, LocationName] = branch.split(" - ");
      //console.log(branchName, LocationName, this.branchesToSelect)
      this.info.BranchId = branchName
        ? this.branchesToSelect.filter(
            (branch) =>
              branch.Name.trim() == branchName &&
              branch.Location.trim() == LocationName
          )[0].Id
        : "";
      //console.log(this.info.BranchId, this.branchesToSelect)
    },

    create() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      //console.log(this.info)
      if (this.info.Branch) {
        this.info.Branch = this.info.Branch.split("-")[0];
      } else {
        this.info.Branch = "";
      }
      console.log(this.info);
      axios
        .post(
          `${this.getOrganization}/setup/department/${this.$ApiVersion}/create`,
          JSON.stringify(this.info),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.$emit("closeOnSuccess");
              this.info = {
                LocationName: null,
                Location: null,
                Branch: null,
                DepartmentManager: null,
                LocationId: null,
                JobTitleId: null,
                BranchId: null,
                Name: null,
                Fullname: null,
              };
            } else {
              this.$notify.error({
                title: "Failure",
                message: response.data.StatusMessage,
              });
            }
          },
          (error) => {
            this.loading = false;

            this.$notify.error({ title: "Failure", message: error.message });
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
